import './index.scss'
// import '../../assets/scripts/myNiceScroll'
// import {resizeScroll} from '../../assets/scripts/myNiceScroll'
import '@fancyapps/fancybox/dist/jquery.fancybox.min'

// 查看更多
var clickNum = 0
var initshowliNum = 3
var showstep = 3
var totalli = $('.section1 .cont:nth-child(1) .video-list li').length

if (totalli <= initshowliNum) {
  $('.section1 .cont:nth-child(1) .more').hide()
}

$('.section1 .cont:nth-child(1) .more span').on('click', function () {
    clickNum += 1
    if (initshowliNum + showstep * clickNum < totalli) {
        for (let i = 0; i < showstep; i++) {
            $('.section1 .cont:nth-child(1) .video-list li').eq(initshowliNum + (clickNum - 1) * showstep + i).show()
        }
    } else {
        for (let i = 0; i < totalli - clickNum * showstep; i++) {
            $('.section1 .cont:nth-child(1) .video-list li').eq(initshowliNum + (clickNum - 1) * showstep + i).show()
        }
        $('.section1 .cont:nth-child(1) .more').hide()
    }
})


var clickNum2 = 0
var initshowliNum2 = 6
var showstep2 = 3
var totalli2 = $('.section1 .cont:nth-child(2) .video-list li').length

if (totalli2 <= initshowliNum2) {
  $('.section1 .cont:nth-child(2) .more').hide()
}

$('.section1 .cont:nth-child(2) .more span').on('click', function () {
    clickNum2 += 1
    if (initshowliNum2 + showstep2 * clickNum2 < totalli2) {
        for (let i = 0; i < showstep2; i++) {
            $('.section1 .cont:nth-child(2) .video-list li').eq(initshowliNum2 + (clickNum2 - 1) * showstep2 + i).show()
        }
    } else {
        for (let i = 0; i < totalli2 - clickNum2 * showstep2; i++) {
            $('.section1 .cont:nth-child(2) .video-list li').eq(initshowliNum2 + (clickNum2 - 1) * showstep2 + i).show()
        }
        $('.section1 .cont:nth-child(2) .more').hide()
    }
})